const isLoading = state => state.app.isLoading

export {
  isLoading,
}
